import { useNavigate } from 'react-router-dom';
import { useToggle } from 'react-use';
import { Common } from '@thecvlb/design-system';

import useWeightManagement from 'hooks/useWeightManagement';
import { PathName } from 'utils/enums';

import { AllSetProps } from './allSet.types';

const AllSet: React.FC<AllSetProps> = ({ onContinue }) => {
  const navigate = useNavigate();
  const [isOpenModal, toggleIsOpenModal] = useToggle(false);
  const { isTTPatient } = useWeightManagement();

  const handleUpdateAnswers = () => {
    onContinue();
    toggleIsOpenModal();
  };

  return (
    <>
      <Common.Modal
        isOpen={isOpenModal}
        close={toggleIsOpenModal}
        size="sm"
        title="Note: your previous answers will not be saved."
        description="You will be required to complete the survey in order to continue receiving medication."
      >
        <div className="flex justify-end gap-3 max-md:flex-col-reverse">
          <Common.Button color="white-alt" fullWidthOnMobile onClick={toggleIsOpenModal}>
            Close
          </Common.Button>
          <Common.Button color="blue" fullWidthOnMobile onClick={handleUpdateAnswers}>
            Yes, update answers
          </Common.Button>
        </div>
      </Common.Modal>
      <div className="flex flex-col items-center gap-4 max-md:h-full md:gap-8">
        <div className="flex flex-col items-center gap-2 text-center max-md:py-6">
          <Common.Illustration name="success" />
          <h2 className="wm-signup-title">You’re all set!</h2>
          <p>
            <span className="font-bold text-gray-700">Thanks for completing your survey.</span>{' '}
            You’re all set to continue your weight loss journey.
          </p>
        </div>
        <div className="mt-auto flex w-full gap-3 max-md:flex-col max-md:py-6 md:justify-center">
          <Common.Button color="blue" fullWidthOnMobile onClick={() => navigate(PathName.Home)}>
            Done
          </Common.Button>
          {!isTTPatient && (
            <Common.Button color="white-alt" fullWidthOnMobile onClick={toggleIsOpenModal}>
              Update my answers
            </Common.Button>
          )}
        </div>
      </div>
    </>
  );
};

export default AllSet;
